import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onStartCourse }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background/90 backdrop-blur-xl border-b border-primary/20 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_care-modules/artifacts/h5qh62ac_logowebapego.png" 
                alt="Logo" 
                className="w-50 h-24 object-contain"
              />
              {/* Subtle glow effect below logo */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-16 h-4 bg-primary/40 rounded-full blur-md" />
            </div>
            <span className="font-semibold text-xl tracking-tight text-foreground">
              Apego<span className="text-primary">Seguro</span>
            </span>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={onStartCourse}
              className="bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 font-medium px-6 py-2 rounded-full"
            >
              COMENZAR CURSO
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-foreground p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-primary/20 pt-4">
            <Button
              onClick={() => {
                onStartCourse();
                setIsMobileMenuOpen(false);
              }}
              className="bg-primary text-primary-foreground hover:bg-primary/90 w-full"
            >
              COMENZAR CURSO
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
